export enum Endpoints {
    SOLUTIONS = 'mail-soluciones',
    CONTACT_US = 'mail-conversemos'
}